import { Button, TableCell, TableRow, Typography } from "@mui/material";

import { NotificationPreferenceSelect } from "./NotificationPreferenceSelect";

interface Props {
  followed: FollowedShipper;
  onUnfollowShipperClicked: (shipper: FollowedShipper) => void;
}

export function EstablishedNetworkTableRow(props: Props) {
  const { followed, onUnfollowShipperClicked } = props;
  return (
    <TableRow key={followed.id}>
      <TableCell>
        <Typography variant="body1">
          {followed.user.first_name} {followed.user.last_name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{followed.company.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{followed.branch?.name ?? "-"}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(followed.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <NotificationPreferenceSelect
          shipperRoleId={followed.id}
          initialPreference={followed.carrier_notification_preference ?? "ALL"}
        />
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          onClick={() => onUnfollowShipperClicked(followed)}
        >
          Unfollow
        </Button>
      </TableCell>
    </TableRow>
  );
}
